import { render, staticRenderFns } from "./StaffAbsenceTypeSlidebar.vue?vue&type=template&id=5a5f4b0c"
import script from "./StaffAbsenceTypeSlidebar.vue?vue&type=script&lang=js"
export * from "./StaffAbsenceTypeSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports